import DefaultBtn from '@/components/btns/DefaultBtn'

export default [
    DefaultBtn
]